import {z} from '@hono/zod-openapi';

/**
 * Constants for use case type values
 */
export const SCAN_VIN = 'scanVIN' as const;
export const SCAN_LICENSE_PLATE = 'scanLicensePlate' as const;
const ENHANCE_MESSAGE = 'enhanceMessage' as const;
const GENERATE_CUSTOMER_EMAIL = 'generateCustomerEmail' as const;
const REFINE_MESSAGE = 'refineMessage' as const;
const SERVICE_INTERVAL_SUMMARY = 'serviceIntervalSummary' as const;
const IMAGE_GENERATION = 'imageGeneration' as const;
export const EXTRACT_DELIVERY_NOTE_DOCUMENT = 'extractDeliveryNoteDocument' as const;
export const IMPORT_NISSAN_PRICE_LIST = 'importNissanPriceList' as const;
export const IMPORT_HONDA_PARTS_PRICE_LIST = 'importHondaPartsPriceList' as const;
export const IMPORT_HONDA_RECALL = 'importHondaRecall' as const;

/**
 * Zod schema for synchronous use cases that execute immediately and return results directly
 */
export const synchronousUseCaseTypeSchema = z.enum([
  SCAN_VIN,
  SCAN_LICENSE_PLATE,
  ENHANCE_MESSAGE,
  GENERATE_CUSTOMER_EMAIL,
  REFINE_MESSAGE,
  SERVICE_INTERVAL_SUMMARY,
  IMAGE_GENERATION,
]);

/**
 * @description Synchronous use cases that execute immediately and return results directly
 */
export type SynchronousUseCaseType = z.infer<typeof synchronousUseCaseTypeSchema>;

/**
 * Zod schema for asynchronous use cases that are processed via messaging queues
 */
export const asynchronousUseCaseTypeSchema = z.enum([
  EXTRACT_DELIVERY_NOTE_DOCUMENT,
  IMPORT_NISSAN_PRICE_LIST,
  IMPORT_HONDA_PARTS_PRICE_LIST,
  IMPORT_HONDA_RECALL,
]);

/**
 * @description Asynchronous use cases that are processed via messaging queues
 */
export type AsynchronousUseCaseType = z.infer<typeof asynchronousUseCaseTypeSchema>;

/**
 * Zod schema for all available use case types in the system
 */
export const useCaseTypeSchema = z.union([
  synchronousUseCaseTypeSchema,
  asynchronousUseCaseTypeSchema,
]);

/**
 * @description Union type of all available use case types in the system
 */
export type UseCaseType = z.infer<typeof useCaseTypeSchema>;
